export const EOS_TOP_PADDING_PX = 50;
export const EOS_TOP_PADDING_PRINT_PX = 25;
